/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChatGptResponseDto } from '../models/chat-gpt-response-dto';
import { proxyControllerCallChatGptApi } from '../fn/proxy/proxy-controller-call-chat-gpt-api';
import { ProxyControllerCallChatGptApi$Params } from '../fn/proxy/proxy-controller-call-chat-gpt-api';
import { proxyControllerProxyAcademoLab } from '../fn/proxy/proxy-controller-proxy-academo-lab';
import { ProxyControllerProxyAcademoLab$Params } from '../fn/proxy/proxy-controller-proxy-academo-lab';
import { proxyControllerProxyAmritaLab } from '../fn/proxy/proxy-controller-proxy-amrita-lab';
import { ProxyControllerProxyAmritaLab$Params } from '../fn/proxy/proxy-controller-proxy-amrita-lab';
import { proxyControllerProxyChemCollectiveLab } from '../fn/proxy/proxy-controller-proxy-chem-collective-lab';
import { ProxyControllerProxyChemCollectiveLab$Params } from '../fn/proxy/proxy-controller-proxy-chem-collective-lab';
import { proxyControllerProxyDuffy } from '../fn/proxy/proxy-controller-proxy-duffy';
import { ProxyControllerProxyDuffy$Params } from '../fn/proxy/proxy-controller-proxy-duffy';
import { proxyControllerProxyGallileoAndEinsteinLab } from '../fn/proxy/proxy-controller-proxy-gallileo-and-einstein-lab';
import { ProxyControllerProxyGallileoAndEinsteinLab$Params } from '../fn/proxy/proxy-controller-proxy-gallileo-and-einstein-lab';
import { proxyControllerProxyHarshuEduLab } from '../fn/proxy/proxy-controller-proxy-harshu-edu-lab';
import { ProxyControllerProxyHarshuEduLab$Params } from '../fn/proxy/proxy-controller-proxy-harshu-edu-lab';
import { proxyControllerProxyHbcseLab } from '../fn/proxy/proxy-controller-proxy-hbcse-lab';
import { ProxyControllerProxyHbcseLab$Params } from '../fn/proxy/proxy-controller-proxy-hbcse-lab';
import { proxyControllerProxyKcvsLab } from '../fn/proxy/proxy-controller-proxy-kcvs-lab';
import { ProxyControllerProxyKcvsLab$Params } from '../fn/proxy/proxy-controller-proxy-kcvs-lab';
import { proxyControllerProxyPage } from '../fn/proxy/proxy-controller-proxy-page';
import { ProxyControllerProxyPage$Params } from '../fn/proxy/proxy-controller-proxy-page';
import { proxyControllerProxySeiliasLab } from '../fn/proxy/proxy-controller-proxy-seilias-lab';
import { ProxyControllerProxySeiliasLab$Params } from '../fn/proxy/proxy-controller-proxy-seilias-lab';
import { proxyControllerProxyUrl } from '../fn/proxy/proxy-controller-proxy-url';
import { ProxyControllerProxyUrl$Params } from '../fn/proxy/proxy-controller-proxy-url';
import { proxyControllerProxyWalterFendt } from '../fn/proxy/proxy-controller-proxy-walter-fendt';
import { ProxyControllerProxyWalterFendt$Params } from '../fn/proxy/proxy-controller-proxy-walter-fendt';
import { proxyControllerRedirect } from '../fn/proxy/proxy-controller-redirect';
import { ProxyControllerRedirect$Params } from '../fn/proxy/proxy-controller-redirect';

@Injectable({ providedIn: 'root' })
export class ProxyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `proxyControllerCallChatGptApi()` */
  static readonly ProxyControllerCallChatGptApiPath = '/proxy/{ilsId}/chatGpt';

  /**
   * Make a call to chat gpt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerCallChatGptApi()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyControllerCallChatGptApi$Response(params: ProxyControllerCallChatGptApi$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatGptResponseDto>> {
    const obs = proxyControllerCallChatGptApi(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Make a call to chat gpt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerCallChatGptApi$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyControllerCallChatGptApi(params: ProxyControllerCallChatGptApi$Params, context?: HttpContext): Observable<ChatGptResponseDto> {
    const resp = this.proxyControllerCallChatGptApi$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ChatGptResponseDto>): ChatGptResponseDto => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyDuffy()` */
  static readonly ProxyControllerProxyDuffyPath = '/proxy/duffy/{url}';

  /**
   * return the modified html for a duffy lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyDuffy()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyDuffy$Response(params?: ProxyControllerProxyDuffy$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyDuffy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a duffy lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyDuffy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyDuffy(params?: ProxyControllerProxyDuffy$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyDuffy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyWalterFendt()` */
  static readonly ProxyControllerProxyWalterFendtPath = '/proxy/walterFendt/{url}';

  /**
   * return the modified html for a walter fendt lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyWalterFendt()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyWalterFendt$Response(params?: ProxyControllerProxyWalterFendt$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyWalterFendt(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a walter fendt lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyWalterFendt$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyWalterFendt(params?: ProxyControllerProxyWalterFendt$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyWalterFendt$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyChemCollectiveLab()` */
  static readonly ProxyControllerProxyChemCollectiveLabPath = '/proxy/chemCollective/{url}';

  /**
   * return the modified html for a chemcollective lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyChemCollectiveLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyChemCollectiveLab$Response(params?: ProxyControllerProxyChemCollectiveLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyChemCollectiveLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a chemcollective lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyChemCollectiveLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyChemCollectiveLab(params?: ProxyControllerProxyChemCollectiveLab$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyChemCollectiveLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyAcademoLab()` */
  static readonly ProxyControllerProxyAcademoLabPath = '/proxy/academo/{url}';

  /**
   * return the modified html for a academo lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyAcademoLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyAcademoLab$Response(params?: ProxyControllerProxyAcademoLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyAcademoLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a academo lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyAcademoLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyAcademoLab(params?: ProxyControllerProxyAcademoLab$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyAcademoLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxySeiliasLab()` */
  static readonly ProxyControllerProxySeiliasLabPath = '/proxy/seilias/{url}';

  /**
   * return the modified html for a seilias lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxySeiliasLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxySeiliasLab$Response(params?: ProxyControllerProxySeiliasLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxySeiliasLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a seilias lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxySeiliasLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxySeiliasLab(params?: ProxyControllerProxySeiliasLab$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxySeiliasLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyKcvsLab()` */
  static readonly ProxyControllerProxyKcvsLabPath = '/proxy/kcvs/{url}';

  /**
   * return the modified html for a kcvs lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyKcvsLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyKcvsLab$Response(params?: ProxyControllerProxyKcvsLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyKcvsLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a kcvs lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyKcvsLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyKcvsLab(params?: ProxyControllerProxyKcvsLab$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyKcvsLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyGallileoAndEinsteinLab()` */
  static readonly ProxyControllerProxyGallileoAndEinsteinLabPath = '/proxy/galileoAndEinstein/{url}';

  /**
   * return the modified html for a galileoAndEinstein lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyGallileoAndEinsteinLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyGallileoAndEinsteinLab$Response(params?: ProxyControllerProxyGallileoAndEinsteinLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyGallileoAndEinsteinLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a galileoAndEinstein lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyGallileoAndEinsteinLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyGallileoAndEinsteinLab(params?: ProxyControllerProxyGallileoAndEinsteinLab$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyGallileoAndEinsteinLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyAmritaLab()` */
  static readonly ProxyControllerProxyAmritaLabPath = '/proxy/amrita/{url}';

  /**
   * return the modified html for an amrita lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyAmritaLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyAmritaLab$Response(params?: ProxyControllerProxyAmritaLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyAmritaLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for an amrita lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyAmritaLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyAmritaLab(params?: ProxyControllerProxyAmritaLab$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyAmritaLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyHarshuEduLab()` */
  static readonly ProxyControllerProxyHarshuEduLabPath = '/proxy/harshuEdu/{url}';

  /**
   * return the modified html for a harshuEdu lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyHarshuEduLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyHarshuEduLab$Response(params?: ProxyControllerProxyHarshuEduLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyHarshuEduLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a harshuEdu lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyHarshuEduLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyHarshuEduLab(params?: ProxyControllerProxyHarshuEduLab$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyHarshuEduLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyHbcseLab()` */
  static readonly ProxyControllerProxyHbcseLabPath = '/proxy/hbcse/{url}';

  /**
   * return the modified html for a hbcse lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyHbcseLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyHbcseLab$Response(params?: ProxyControllerProxyHbcseLab$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = proxyControllerProxyHbcseLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the modified html for a hbcse lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyHbcseLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyHbcseLab(params?: ProxyControllerProxyHbcseLab$Params, context?: HttpContext): Observable<string> {
    const resp = this.proxyControllerProxyHbcseLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `proxyControllerRedirect()` */
  static readonly ProxyControllerRedirectPath = '/proxy/redirect/{url}';

  /**
   * redirect to the given url.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerRedirect()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerRedirect$Response(params?: ProxyControllerRedirect$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = proxyControllerRedirect(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * redirect to the given url.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerRedirect$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerRedirect(params?: ProxyControllerRedirect$Params, context?: HttpContext): Observable<void> {
    const resp = this.proxyControllerRedirect$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyUrl()` */
  static readonly ProxyControllerProxyUrlPath = '/proxy/url/{url}';

  /**
   * return the content of the given url.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyUrl$Response(params?: ProxyControllerProxyUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = proxyControllerProxyUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the content of the given url.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyUrl(params?: ProxyControllerProxyUrl$Params, context?: HttpContext): Observable<void> {
    const resp = this.proxyControllerProxyUrl$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `proxyControllerProxyPage()` */
  static readonly ProxyControllerProxyPagePath = '/proxy/page/{url}';

  /**
   * return the content of the given url, with absolute urls replaced.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyControllerProxyPage()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyPage$Response(params?: ProxyControllerProxyPage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = proxyControllerProxyPage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * return the content of the given url, with absolute urls replaced.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `proxyControllerProxyPage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyControllerProxyPage(params?: ProxyControllerProxyPage$Params, context?: HttpContext): Observable<void> {
    const resp = this.proxyControllerProxyPage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
